import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { ThunkDispatch } from 'redux-thunk'
import type { AnyAction } from 'redux'

import { store } from 'src/reducers'

/**
 * Tipos base del store. Mientras `src/reducers` siga en JS `RootState` se
 * resuelve a `any`; al tipar los reducers estos tipos se ajustan solos sin
 * tocar los componentes. Es el punto de entrada para el tipado incremental.
 */
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>

/** Hooks tipados: usar en lugar de `useDispatch`/`useSelector` planos. */
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
